import { render, staticRenderFns } from "./date-multi-calendar.vue?vue&type=template&id=87c9a42c&scoped=true"
import script from "./date-multi-calendar.vue?vue&type=script&lang=js"
export * from "./date-multi-calendar.vue?vue&type=script&lang=js"
import style0 from "./date-multi-calendar.vue?vue&type=style&index=0&id=87c9a42c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c9a42c",
  null
  
)

export default component.exports